import { h, render, Component } from 'preact';
import WidgetLoader from './WidgetLoader';
import {GetTopWidgetName} from '../utils/widgetUtil';


export default class BottomWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedWidgets: {}
        }
    }
    componentDidMount() {
    }
    setWidgetProp(widgetName, propName, propVal) {
        this.setState(c => {
            if(!c.loadedWidgets[widgetName]) {
                c.loadedWidgets[widgetName] = {};
            }
            c.loadedWidgets[widgetName][propName] = propVal;
            return c;
        });
    }
    render () {
        let widget = GetTopWidgetName("bottom", this.props.searchResp);
        let wdgName = widget?.name;
        let wdgProps = widget?.props ?? {};
        if(!wdgName) {
            return ("");
        }
        if(wdgName === "NA") {
            return ("")
                {/*<div id="affSearchWidget1" className="aff-search-widget">
                    <WidgetLoader name="affsearch" 
                        {...this.props} {...wdgProps}
                        setWidgetProp={this.setWidgetProp.bind(this)}
                    />
            </div>*/}
        }
    } 
}
